<template>
    <div class="about-us">
      <div class="about-content">
        <h2 class="title">请与我们联系</h2>
        <div class="bar">
          <div class="circular"></div>
        </div>
        <p class="subheading">我们很愿意为您提供帮助,共创美好未来</p>
        <div class="solution">
          <div class="solution-content">
            <div class="grid-content">
                <div class="icon">
                  <v-icon class="icon-img phone" name="phone"/>
                </div>
                <h3>电话联系</h3>
                <p class="detailed distraction">
                  0451-51855226
                </p>
            </div>
          </div>
          <div class="solution-content">
            <div class="grid-content">
                <div class="icon">
                  <v-icon class="icon-img" name="envelope"/>
                </div>
                <h3>邮箱联系</h3>
                <p class="detailed distraction">
                  support@togotech.cn
                </p>
            </div>
          </div>
          <div class="solution-content">
            <div class="grid-content">
              <div class="icon">
                <v-icon class="icon-img" name="map"/>
              </div>
              <h3>公司地址</h3>
              <p class="detailed">
                哈尔滨市松北区科技一街399号4层
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: 'About'
}
</script>

<style lang="scss" scoped>
.about-us{
  padding-top: 70px;
  padding-bottom: 40px;
}

.title{
  margin-top: 0px;
  margin-bottom: 40px;
}

.about-content{
  position: relative;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;

  @media (max-width: 576px) {
    padding: 0px;
  }

  @media (min-width: 576px) {
    max-width: 540px;
  }

  @media (max-width: 767px) {
    .solution{
      display: block;
    }
  }

  @media (min-width: 768px) {
    // max-width: 620px;
    max-width: 760px;
    padding: 0px;
  }

  @media (min-width: 992px) {
    max-width: 860px;
  }

  @media (min-width: 768px) and (max-width: 1199px) {
    .grid-content {
      .distraction{
        line-height: 52px;
      }
    }
  }

  @media (min-width: 1200px) {
    max-width: 1140px;
  }
}

.title{
  font-size: 22px;
  margin: 0;
}

.bar{
  height: 4px;
  width: 90px;
  background: #cdf1d8;;
  margin: 20px auto;
  position: relative;
  border-radius: 40px;

  .circular{
    position: absolute;
    left: 0;
    top: -3.2px;
    height: 10px;
    width: 10px;
    border-radius: 50%;
    background: #44ce6f;
    animation:mymove 4s infinite;
    -webkit-animation:mymove 4s infinite; /*Safari and Chrome both*/
    
    @keyframes mymove
    {
      from {
        left: 0px;
      }

      to {
        left: 82px;
      }
    }
   
    @-webkit-keyframes mymove /*Safari and Chrome*/
    {
      from {
        left: 0px;
      }

      to {
        left: 82px;
      }
    }
  }
}

.subheading {
  font-size: 14px;
  max-width: 520px;
  margin: 0 auto;
  margin-bottom: 30px;
  color: #6084a4;
  line-height: 1.9;
}

.solution {
  display: flex;
  &:last-child {
    margin-bottom: 0;
  }
}

.solution-content {
  position: relative;
  padding: 0 15px;
  flex: 1;
}

.grid-content {
  position: relative;
  margin-bottom: 30px;
  padding: 30px;
  text-align: center;
  box-shadow: 0 2px 48px 0 rgba(0, 0, 0, 0.08);
  background: #ffffff;
  z-index: 1;
  -webkit-transition: 0.5s;
  transition: 0.5s;

  h3 {
    transition: 0.5s;
    margin-top: 22px;
    margin-bottom: 17px;
    line-height: 1.4;
    z-index: 999;
    font-size: 16px;
    font-weight: 500;
    color: #0e314c;
  }

  p {
    margin-bottom: 0px;
    transition: 0.9s;
    font-size: 14px;
    color: #6084a4;
    line-height: 1.9;
    letter-spacing:1px
  }

  &:hover{
    transform: translateY(-10px);
    .icon{
      background: #44ce6f;
       &>.icon-img{
         color: #ffffff;
       }
    }
  }
}

.icon {
  display: inline-block;
  width: 65px;
  height: 65px;
  line-height: 78px;
  border-radius: 50%;
  background: #f7fafd;
  -webkit-transition: 0.5s;
  transition: 0.5s;
  &>.icon-img{
    width: 24px;
    height: 24px;
    color: #44ce6f;
  }
}

.phone{
  transform: rotateY(180deg)
}
</style>